import { FC, useEffect, useState } from "react";
import styled from "styled-components";

import { Input } from "@/components/Forms";
import useDebounce from "@/hooks/useDebounce";

const Wrap = styled.div`
  position: relative;
  margin: 0 0 16px;
`;

const SearchInput = styled(Input)`
  height: 40px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  padding: 0 40px;
`;

const Icon = styled.svg`
  position: absolute;
  left: 16px;
  top: 11px;
  color: ${({ theme }) => theme.colors.gray};
`;

interface Props {
  setValue: (value: string) => void;
  placeholder?: string;
  initialValue?: string;
}

const InvoicesSearchBar: FC<Props> = ({ setValue, placeholder = "Search", initialValue = "" }) => {
  const [search, setSearch] = useState<string>(initialValue);

  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    setValue(debouncedSearch);
  }, [debouncedSearch, setValue]);

  return (
    <Wrap>
      <Icon
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.58101 14.5385C11.1357 14.5385 14.0173 11.6455 14.0173 8.07693C14.0173 4.50832 11.1357 1.61539 7.58101 1.61539C4.02634 1.61539 1.14471 4.50832 1.14471 8.07693C1.14471 11.6455 4.02634 14.5385 7.58101 14.5385Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1321 12.6462L15.856 16.3847"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Icon>
      <SearchInput
        placeholder={placeholder}
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    </Wrap>
  );
};

export default InvoicesSearchBar;
